<template>
    <div class="bodyClass">
        <!--首页大框-->
        <div class="ph-top-box">
            <!--菜单-->

            <!--菜单end-->
            <!--背景滚动钮-->
            <div class="ph-annui">
                <mobileMenu />
                <!-- <div class="ph-logo-a3 mt10 pl10"><a href="#" class="dbi fl he40"><img
                            src="../../assets/mobile/images/logo2.png" width="" height="45" alt="" /></a><a href="#"
                        class="dbi fr he20 white pr10 mt14 mr12"><span class="f14 txtsh">MENU</span> <i
                            class="fa fa-bars f18 txtsh"></i></a></div> -->
                <!--弹出菜单-->
                <!-- <div class="ph-phone-mu" style="">
                    <ul class="ph-ph-um-ul">
                        <li class="ph-ph-mu-li mt10"><a href="homeWeb.html" class="db  f15 lp2 pl10 white txtsh">首页</a>
                        </li>
                        <li class="ph-ph-mu-li mt10"><a href="chanping-1.html"
                                class="db white f15 lp2 pl10 txtsh">产品</a>
                            <div class="" style="">
                                <a class="db he34 ml50 ph-pml-a" href="chanping-4.html">视觉智能体</a>
                                <a class="db he34 ml50 ph-pml-a" href="chanping-3.html">新一代公共安全视觉智能体</a>
                                <a class="db he34 ml50 ph-pml-a" href="chanping-1.html">视觉大模型平台</a>
                                <a class="db he34 ml50 ph-pml-a" href="chanping-2.html">视觉大模型一体机</a>
                            </div>
                        </li>
                        <li class="ph-ph-mu-li mt10"><a href="jiejfa-1.html"
                                class="db white txtsh f15 lp2 pl10">解决方案</a>
                            <div class="" style="">
                                <a class="db he34 ml50 ph-pml-a" href="jiejfa-1.html">公共安全行业解决方案</a>
                                <a class="db he34 ml50 ph-pml-a" href="yijii-2.html">应急行业解决方案</a>
                                <a class="db he34 ml50 ph-pml-a" href="chengguan-3.html">城管行业解决方案</a>
                                <a class="db he34 ml50 ph-pml-a" href="jiaotong-4.html">交通行业解决方案</a>
                                <a class="db he34 ml50 ph-pml-a" href="qiyuegl-5.html">企业管理解决方案</a>
                            </div>
                        </li>
                        <li class="ph-ph-mu-li mt10"><a href="severHtml.html"
                                class="db white txtsh f15 lp2 pl10">服务&生态</a></li>
                        <li class="ph-ph-mu-li mt10"><a href="gywmHtml.html"
                                class="db white txtsh f15 lp2 pl10">关于我们</a></li>
                    </ul>
                </div> -->
                <!--弹出菜单-->
                <div class="ph-annui-b tc">
                    <a class="dbi wi20 he20 tc">
                        <i
                            :class="'fa f15 wi20 white he20' + (showChangeDpCheck == 1 ? ' fa-dot-circle-o' : ' fa-circle-o')">
                        </i>
                    </a>
                    <a class="dbi wi20 he20 tc">
                        <i
                            :class="'fa f15 wi20 white he20' + (showChangeDpCheck == 2 ? ' fa-dot-circle-o' : ' fa-circle-o')">
                        </i>
                    </a>
                    <a class="dbi wi20 he20 tc">
                        <i
                            :class="'fa f15 wi20 white he20' + (showChangeDpCheck == 3 ? ' fa-dot-circle-o' : ' fa-circle-o')">
                        </i>
                    </a>
                    <a class="dbi wi20 he20 tc">
                        <i
                            :class="'fa f15 wi20 white he20' + (showChangeDpCheck == 4 ? ' fa-dot-circle-o' : ' fa-circle-o')">
                        </i>
                    </a>
                    <a class="dbi wi20 he20 tc">
                        <i
                            :class="'fa f15 wi20 white he20' + (showChangeDpCheck == 5 ? ' fa-dot-circle-o' : ' fa-circle-o')">
                        </i>
                    </a>
                    <a class="dbi wi20 he20 tc">
                        <i
                            :class="'fa f15 wi20 white he20' + (showChangeDpCheck == 6 ? ' fa-dot-circle-o' : ' fa-circle-o')">
                        </i>
                    </a>
                </div>
                <div class="ph-annui-t tc">
                    <a class="dbi wi40 he40 tc ph-anim"><i class="fa fa-angle-double-down f28 wi20 white he20"></i></a>
                </div>
            </div>
            <!--背景滚动钮end-->
            <!--文字-->
            <div class="ph-big-txt" v-show="showChangeDpCheck == 1">
                <div class="ph-gig-txt-a tc">
                    <div class="dbi">
                        <h3 class="">谛视万象vix</h3>
                        <h4 class="mt20 f15">谛观万象 智视未来</h4>
                        <p class="mt30">谛视万象多模态视觉大模型</p>
                    </div>
                </div>
            </div>
            <div class="ph-big-txt" v-show="showChangeDpCheck == 2">
                <div class="ph-gig-txt-a tc">
                    <div class="dbi">
                        <h3 class="">分钟级算法创建</h3>
                        <h4 class="mt20 f15">小时级部署上线</h4>
                        <p class="mt30">从算法创建完成到上线使用仅需小时级时间</p>
                    </div>
                </div>
            </div>
            <div class="ph-big-txt" v-show="showChangeDpCheck == 3">
                <div class="ph-gig-txt-a tc">
                    <div class="dbi">
                        <h3 class="">视觉智能分析基座</h3>
                        <h4 class="mt20 f15">以视觉感知能力为核心</h4>
                        <p class="mt30">助力各行业智能化升级与跨越式发展</p>
                    </div>
                </div>
            </div>
            <div class="ph-big-txt" v-show="showChangeDpCheck == 4">
                <div class="ph-gig-txt-a tc">
                    <div class="dbi">
                        <h3 class="">视觉大模型一体机</h3>
                        <h4 class="mt20 f15">一站式智能设备</h4>
                        <p class="mt30">人工智能视觉大模型平台与高性能计算硬件的一站式智能设备</p>
                    </div>
                </div>
            </div>
            <div class="ph-big-txt" v-show="showChangeDpCheck == 5">
                <div class="ph-gig-txt-a tc">
                    <div class="dbi">
                        <h3 class="">新一代公共安全视觉智能体</h3>
                        <h4 class="mt20 f15">自主安防感知与决策智能体</h4>
                        <p class="mt30">融合多种智能终端，实时感知、分析、预警</p>
                    </div>
                </div>
            </div>
            <div class="ph-big-txt" v-show="showChangeDpCheck == 6">
                <div class="ph-gig-txt-a tc">
                    <div class="dbi">
                        <h3 class="">视觉智能体</h3>
                        <h4 class="mt20 f15">融合视觉大模型与智能体</h4>
                        <p class="mt30">视觉感知动态环境精准视觉分析服务</p>
                    </div>
                </div>
            </div>
            <!--文字eend-->
            <!--背景图-->
            <div class="top-backgr">
                <transition name="slide" @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false">
                    <div class="ph-top-backgr-img bg-animated img1" v-show="showChangeDpCheck == 1"> </div>
                </transition>
                <transition name="slide" @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false">
                    <div class="ph-top-backgr-img bg-animated img2" v-show="showChangeDpCheck == 2"> </div>
                </transition>
                <transition name="slide" @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false">
                    <div class="ph-top-backgr-img bg-animated img3" v-show="showChangeDpCheck == 3"> </div>
                </transition>
                <transition name="slide" @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false">
                    <div class="ph-top-backgr-img bg-animated img4" v-show="showChangeDpCheck == 4"> </div>
                </transition>
                <transition name="slide" @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false">
                    <div class="ph-top-backgr-img bg-animated img5" v-show="showChangeDpCheck == 5"> </div>
                </transition>
                <transition name="slide" @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false">
                    <div class="ph-top-backgr-img bg-animated img6" v-show="showChangeDpCheck == 6"> </div>
                </transition>
            </div>
            <!--背景图end-->

            <!--首页大框end-->
        </div>
        <!--首页大框-->
        <!--内容大框-->
        <div class="ph-main pt24">
            <!--菜单-->
            <div class="ph-main-menu tc" style="display:none;">
                <ul class="ph-main-m-a1 dbi">
                    <li><a href="/mb/homeWebMb" class="ph-txt-2">首页</a></li>
                    <li><a href="/mb/chanping1Mb" class="ph-txt-2">产品</a>
                        <div class="ph-li-div" style="width:1000px;top:140px;">
                            <div class="ph-li-div-left fl"> <span class="tl dbi">产品</span> </div>
                            <div class="w60 fl">
                                <ul class="">
                                    <li class="" style="width:30%"> <a class="dbi  w100 ph-menu-atxt21"
                                            href="/mb/chanping1Mb">
                                            <div class="ph-li-div-d2 mt10 "> <img
                                                    src="../../assets/mobile/images/z1-ytj.png" class="ph-li-div-img">
                                            </div>
                                            <h1 class="f16 lh40 white">视觉大模型平台</h1>
                                        </a> </li>
                                    <li style="width:30%"> <a class="dbi  w100 ph-menu-atxt21" href="/mb/chanping2Mb">
                                            <div class="ph-li-div-d2 mt10 "> <img
                                                    src="../../assets/mobile/images/z2-ytj.png" class="ph-li-div-img">
                                            </div>
                                            <h1 class="f16 lh40 white">视觉大模型一体机</h1>
                                        </a> </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                    <li><a href="/mb/jiejfa1Mb" class="">解决方案</a>
                        <div class="ph-li-div" style="width:1300px;top:140px">
                            <div class="ph-li-div-left fl" style="width:220px"> <span class="tl dbi">解决方案</span> </div>
                            <div class="w70 fl" style="height:148px;">
                                <ul class="">
                                    <li> <a class="dbi  w100 ph-menu-atxt21" href="/mb/jiejfa1Mb">
                                            <div class="ph-li-div-d2 mt10 "> <img
                                                    src="../../assets/mobile/images/z3-ytj.png" class="ph-li-div-img">
                                            </div>
                                            <h1 class="f16 lh40 white">公共安全行业解决方案</h1>
                                        </a> </li>
                                    <li> <a class="dbi  w100 ph-menu-atxt21" href="/mb/yijii2Mb">
                                            <div class="ph-li-div-d2 mt10 "> <img
                                                    src="../../assets/mobile/images/z4-ytj.png" class="ph-li-div-img">
                                            </div>
                                            <h1 class="f16 lh40 white">应急行业解决方案</h1>
                                        </a> </li>
                                    <li> <a class="dbi  w100 ph-menu-atxt21" href="/mb/chengguan3Mb">
                                            <div class="ph-li-div-d2 mt10 "> <img
                                                    src="../../assets/mobile/images/z5-ytj.png" class="ph-li-div-img">
                                            </div>
                                            <h1 class="f16 lh40 white">应急行业解决方案</h1>
                                        </a> </li>
                                    <li> <a class="dbi  w100 ph-menu-atxt21" href="/mb/jiaotong4Mb">
                                            <div class="ph-li-div-d2 mt10 "> <img
                                                    src="../../assets/mobile/images/z6-ytj.png" class="ph-li-div-img">
                                            </div>
                                            <h1 class="f16 lh40 white">交通行业解决方案</h1>
                                        </a> </li>
                                    <li> <a class="dbi  w100 ph-menu-atxt21" href="/mb/qiyeigl5Mb">
                                            <div class="ph-li-div-d2 mt10 "> <img
                                                    src="../../assets/mobile/images/z7-ytj.png" class="ph-li-div-img">
                                            </div>
                                            <h1 class="f16 lh40 white">企业管理解决方案</h1>
                                        </a> </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                    <li><a href="/mb/severHtmlMb" class="ph-txt-2">服务&生态</a></li>
                    <li><a href="/mb/gywmHtmlMb" class="ph-txt-2">关于我们</a></li>
                </ul>
            </div>
            <!--菜单end-->
            <!--解决方案-->
            <div class="w100 lh40 tc"> <span class="db f40 fb lp2 mt40">解决方案</span> <span
                    class="db f22  lp2 mt20 ph-col-gr ph-abcd">Solution</span> </div>
            <div class="mt150 ph-jjfa">
                <div class="ph-jjfa-block tc pl4 pr4">
                    <ul>
                        <li class=""> <a class="dbi " href="/mb/jiejfa1Mb">
                                <div class="tc"><img src="../../assets/mobile/images/z3-ytj.png" width="90" alt=""
                                        class="mt30" /></div>
                                <div class="tc white f15 mt10">公共安全行业解决方案</div>
                                <div class="tc white f12 ph-col-gr1 mt6">PUBLIC SECURITY INDUSTRY</div>
                            </a> </li>
                        <li> <a class="dbi" href="/mb/yijii2Mb">
                                <div class="tc"><img src="../../assets/mobile/images/z4-ytj.png" width="90" alt=""
                                        class="mt30" /></div>
                                <div class="tc white f15 mt10">应急行业解决方案</div>
                                <div class="tc white f12 ph-col-gr1 mt6">EMERGENCY INDUSTRY</div>
                            </a> </li>
                        <li> <a class="dbi" href="/mb/chengguan3Mb">
                                <div class="tc"><img src="../../assets/mobile/images/z5-ytj.png" width="90" alt=""
                                        class="mt30" /></div>
                                <div class="tc white f15 mt10">城管行业解决方案</div>
                                <div class="tc white f12 ph-col-gr1 mt6">URBAN MANAGEMENT INDUSTRY</div>
                            </a> </li>
                        <li> <a class="dbi" href="/mb/jiaotong4Mb">
                                <div class="tc"><img src="../../assets/mobile/images/z6-ytj.png" width="90" alt=""
                                        class="mt30" /></div>
                                <div class="tc white f15 mt10">交通行业解决方案</div>
                                <div class="tc white f12 ph-col-gr1 mt6">TRANSPORTATION INDUSTRY</div>
                            </a> </li>
                        <li> <a class="dbi" href="/mb/qiyeigl5Mb">
                                <div class="tc"><img src="../../assets/mobile/images/z7-ytj.png" width="90" alt=""
                                        class="mt30" /></div>
                                <div class="tc white f15 mt10">企业管理解决方案</div>
                                <div class="tc white f12 ph-col-gr1 mt6">BUSINESS MANAGEMENT</div>
                            </a> </li>
                    </ul>
                </div>
                <div class="ph-jjfa-img tc"
                    style="">
                    <p class="mt120 fb white lp2 f15 txtsh"></p>
                    <a class="dbi ph-jjfa-a mt20" href="/mb/jiejfa1Mb">了解方案详情</a>
                </div>
                <!-- <div class="jjfa-img tc" style="background:url(../../assets/mobile/images/y-b-2.jpg) center no-repeat;">
      <p class="mt120 fb white lp2 f15 txtsh">灾害监控预警、人员危险识别<br/>
        根据应急行业实际业务需要确定需要监测的场景</p>
      <a class="dbi jjfa-a mt50" href="yijii2.html">了解产品详情</a> </div>
    <div class="jjfa-img tc" style="background:url(../../assets/mobile/images/y-b-3.jpg) center no-repeat;">
      <p class="mt120 fb white lp2 f15 txtsh">公共设施管理、环境治理<br/>
        根据城管行业实际业务需要确定需要监测的场景</p>
      <a class="dbi jjfa-a mt50" href="chengguan3.html">了解产品详情</a> </div>
    <div class="jjfa-img tc" style="background:url(../../assets/mobile/images/y-b-4.jpg) center no-repeat;">
      <p class="mt120 fb white lp2 f15 txtsh">路面识别、车内人员状态<br/>
        根据交通行业实际业务需要确定需要监测的场景</p>
      <a class="dbi jjfa-a mt50" href="jiaotong4.html">了解产品详情</a> </div>
    <div class="jjfa-img tc" style="background:url(../../assets/mobile/images/y-b-5.jpg) center no-repeat;">
      <p class="mt120 fb white lp2 f15 txtsh">设备识别，人员状态<br/>
        根据企业行业实际业务需要确定需要监测的场景</p>
      <a class="dbi jjfa-a mt20" href="qiyeigl5.html">了解产品详情</a> </div>-->
            </div>
            <!--解决方案end-->
            <!--应用场景展示-->
            <div class="ph-yycj">
                <div class="w95 ph-clearfloat jz">
                    <div class="w100 fl mt30 ">
                        <div><a class="db tl white lp2 f24 ph-a-b" href="/mb/jiejfa1Mb">谛视万象 MixZero具身智能体平台</a></div>
                        <div class="mt20">
                            <video width="100%" height="" class="imgf" autoplay loop controls muted> 视频文件路径
                                 <source src="../../assets/mobile/images/minzero.mp4" type="video/mp4">
                                     可以添加多个
                                 <source>
                                    标签来提供不同格式的视频文件，以兼容不同的浏览器
                                 <source src="your-video-file.ogg" type="video/ogg">
                                    抱歉，你的浏览器不支持HTML5视频。
                            </video>
                            <!-- <a class="dbi" href="/mb/jiejfa1Mb"><img src="../../assets/mobile/images/bg5.jpg" width="100%" height="" alt="" /></a>-->
                        </div>
                        <div class="f16 white mt20">智能安防无人巡控方案</div>
                        <div class="f16 white mt30 fb"><a
                                class="dbi white">以视觉智能为底座，让机器看懂世界、即刻行动</a></div>
                        <div class="mt30 ph-col-gr1 lp1 lh24">
                            新一代智能无人安防无人车，由谛视万象MixZero具身智能本体平台深度赋能，联合新石器无人车底盘与江铃改装专业车辆制造能力，打造新一代AI无人安防巡逻解决方案。在火车站安保实战中，MixZero作为"机器控制大脑"，将视觉大模型对开放世界的理解力，实时转化为设备的精准行动力。
                        </div>
                    </div>
                </div>
            </div>
            <!--应用场景展示end-->
            <!--产品-->
            <div class="w100 lh40 tc mt20"> <span class="db f40 fb lp2 mt10">产品</span> <span
                    class="db f22  lp2 mt20 ph-col-gr">PRODUCT</span> </div>
            <div class="ph-produ jz mt40">
                <div class="fl ph-produ-da4 tc">
                    <p class="mt40 fb white lp2 f18 txtsh">谛视万象视觉智能体</p>
                    <a class="dbi ph-produ-a mt50 txtsh" href="/mb/chanping4Mb">了解产品详情</a>
                </div>
                <div class="fr ph-produ-da1 tc">
                    <p class="mt40 fb white lp2 f18 txtsh">谛视万象多模态视觉大模型</p>
                    <a class="dbi ph-produ-a mt25 txtsh" href="/mb/chanping1Mb">了解产品详情</a>
                </div>
                <div class="fl ph-produ-da3 tc mt10">
                    <p class="mt40 fb white lp2 f18 txtsh">新一代公共安全视觉智能体</p>
                    <a class="dbi ph-produ-a mt25 txtsh" href="/mb/chanping3Mb">了解产品详情</a>
                </div>
                <div class="fr ph-produ-da2 tc mt10">
                    <p class="mt40 fb white lp2 f18 txtsh">视觉大模型一体机</p>
                    <a class="dbi ph-produ-a mt50 txtsh" href="/mb/chanping2Mb">了解产品详情</a>
                </div>
                
                
            </div>
            <!--产品end-->
            <!--合作伙伴-->
            <div class="w100 lh60 tc mt40"> <span class="db f40 fb lp2 mt10">合作伙伴</span> <span
                    class="db f20  lp1 mt20 ph-col-gr">PARTNERS CUSTOMERS</span> </div>
            <div class="w100 mt10">
                <div class="ph-hzhb jz">
                    <div class="ph-hzhb-b"> </div>
                    <div class="ph-hzhb-a"></div>
                </div>
            </div>
            <!--合作伙伴end-->
            
        </div>
        <!--内容大框end-->

        <!--底宣2-->
        <div class="ph-btto-b-a1 ov mt40">
            <div class="mt10 w95 jz pt10 pb10">
                <div class="tc"> <img src="../../assets/mobile/images/ying-28.jpg" width="76" height="76" alt="" class="dbi" /> </div>
                <ul class="w100 ov mt10">
                    <li class="tc">
                        <div class=" f16 white tc">上海谛视万象科技有限公司</div>
                        <div class="ov mt10 tc"><span class="dbi ph-btto-b-sp "><img src="../../assets/mobile/images/ico2_3.png" width="28" height="28" alt="" /></span><span class="dbi  ml10 mt4 f14 ph-col-gr3">联系电话：4007628008</span></div>
                    </li>
      
                </ul>
            </div>
        </div>
        <!--底宣2end-->
        <!--底宣3-->
        <div class="he90 tc ph-btto-c">
            <span class="db ph-col-gr3  pt18">辽ICP备2025061615号</span>
            <span class="db ph-col-gr3  mt10">Copyright © 2004 - 2025 谛视万象版权所有</span>
        </div>
        <!--底宣3end-->
    </div>
</template>
<script setup>
// onMounted,  onUnmounted,
import { onMounted, ref } from 'vue';
import * as WOW from 'wowjs';

import mobileMenu from './mobile-menu.vue';

const menuShowState = ref(false)
const showChangeDpCheck = ref(1)
// const contentClasses = ref('')

onMounted(() => {
    showChangeDp();
    menuShowState.value = false

    new WOW.WOW({
        // boxClass: 'wow',
        animateClass: 'animate__animated',
        offset: 50,       // 元素进入视口 100px 后触发
        // mobile: true,      // 移动端启用
        live: true,        // 监听动态添加的元素
    }).init();
})

// function menuClick() {
//     if (!menuShowState.value) {
//         contentClasses.value = 'WOW animate__animated animate__fadeInRight'
//         menuShowState.value = true
//     }
//     else {
//         contentClasses.value = 'WOW animate__animated animate__fadeOutRight'
//     }
//     // menuShowState.value = !menuShowState.value
// }

// function handleAnimationEnd() {
//     if (menuShowState.value && contentClasses.value == 'WOW animate__animated animate__fadeOutRight') {
//         menuShowState.value = false
//     }
// }

function showChangeDp() {
    setTimeout(() => {
        loopShowFunc()
        showChangeDp()
    }, 4000);
}

function loopShowFunc() {
    if (showChangeDpCheck.value < 6) {
        showChangeDpCheck.value = showChangeDpCheck.value + 1
    }
    else {
        showChangeDpCheck.value = 1
    }
}

// function addAndDelFunc(typeState) {
//     if (typeState == 'add') {
//         // showChangeDpCheck.value
//         if (showChangeDpCheck.value < 6) {
//             showChangeDpCheck.value = showChangeDpCheck.value + 1
//         }
//         else {
//             showChangeDpCheck.value = 1
//         }
//     }
//     if (typeState == 'del') {
//         if (showChangeDpCheck.value != 1) {
//             showChangeDpCheck.value = showChangeDpCheck.value - 1
//         }
//         else {
//             showChangeDpCheck.value = 6
//         }
//     }
// }

// function checkMunFunc(checkNum) {
//     showChangeDpCheck.value = checkNum
// }

const beforeEnter = (el) => {
    el.style.opacity = 0;
    el.style.transform = 'translateY(-20px)';
};
const enter = (el, done) => {
    requestAnimationFrame(() => {
        el.style.transition = 'opacity 0.5s ease, transform 0.3s ease';
        el.style.opacity = 1;
        el.style.transform = 'translateY(0)';
        done(); // 动画完成后调用
    });
};

const leave = (el, done) => {
    el.style.transition = 'opacity 0.5s ease, transform 0.3s ease';
    el.style.opacity = 0;
    el.style.transform = 'translateY(-20px)';
    setTimeout(done, 300);
};



</script>
<style scoped>
@import '@/assets/mobile/css/default.css';
@import '@/assets/mobile/css/font-awesome.min.css';
@import '@/assets/mobile/css/margin.css';
@import '@/assets/mobile/css/main.css';

.img1 {
    background: url(../../assets/mobile/images/bana-1.jpg) center center no-repeat;
    background-size: cover;
}

.img2 {
    background: url(../../assets/mobile/images/bana-2.jpg) center center no-repeat;
    background-size: cover;
}

.img3 {
    background: url(../../assets/mobile/images/bana-4.jpg) center center no-repeat;
    background-size: cover;
}

.img4 {
    background: url(../../assets/mobile/images/bana-3.jpg) center center no-repeat;
    background-size: cover;
}
.img5 {
    background: url(../../assets/mobile/images/bana-14.jpg) center center no-repeat;
    background-size: cover;
}

.img6 {
    background: url(../../assets/mobile/images/bana-15.jpg) center center no-repeat;
    background-size: cover;
}


.animate__animated {
    animation-duration: 2s !important;
}

@layer utilities {
    .content-auto {
        content-visibility: auto;
    }

    .bg-zoom-container {
        overflow: hidden;
        position: relative;
        height: 100vh;
        width: 100%;
    }

    .bg-animated {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        animation: zoomIn 9s infinite alternate ease-in-out;
    }
}


@keyframes zoomIn {
    0% {
        transform: scale(1);
    }

    100% {
        transform: scale(1.5);
    }
}
</style>